import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/roomService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import queryString from "query-string";

class RoomEditForm extends Form {
  state = {
    expiryDate: new Date(),
    data: {
      room_number: "",
      name: "",
      mobile: "",
      rent: "",
      emirates_id: "",
    },
    errors: {},
  };

  schema = {
    room_number: Joi.string().required().label("Ledger type"),
    name: Joi.string().required().label("Name"),
    mobile: Joi.string().required().label("Mobile"),
    rent: Joi.number().required().label("Rent"),
    emirates_id: Joi.allow("").label("Emirates Id"),
  };

  handleChangeExpiry = (date) => {
    this.setState({
      expiryDate: date,
    });
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(account) });

      const dateData = this.mapingData(account);

      this.setState({
        expiryDate: new Date(dateData.expiryDate),
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  mapingData(account) {
    return {
      expiryDate: account.expiry_date,
    };
  }

  async componentDidMount() {
    await this.populateAccount();
  }

  mapToViewModel(account) {
    return {
      room_number: account.room_number,
      name: account.name,
      mobile: account.mobile,
      rent: account.rent,
      emirates_id: account.emirates_id,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(ledgerTypeId);
      this.setState({ blocking: true });

      // let formData = new FormData();
      // formData.append("room_number", this.state.data.room_number);
      // formData.append("name", this.state.data.name);
      // formData.append("mobile", this.state.data.mobile);
      // formData.append("rent", this.state.data.rent);

      let event = new Date(this.state.expiryDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      //formData.append("expiry_date", date);
      // formData.append("_method", "PUT");

      data.expiry_date = date;

      await updateSingle(data);
      this.setState({ blocking: false });
      toast.success("Account has been updated successfully.");
      this.props.history.push("/rooms-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.room_number)
          errors.room_number = ex.response.data.errors.room_number;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.rent)
          errors.rent = ex.response.data.errors.rent;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/room.png";
    const { keyword, status } = queryString.parse(this.props.location.search);

    // if (auth.getCurrentUser().email != "company-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update room account</h1>
        <Link
          to={`/rooms-accounts?keyword=${keyword}&status=${status}`}
          className="btn btn--secondary"
          style={{ marginBottom: "1rem", display: "inline-block" }}
        >
          Back
        </Link>
        <br />
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update room account</h3>
              <p>Provide the information below to update the account.</p>

              {this.renderInput("room_number", "Room Number", "text")}
              {this.renderInput("name", "Incharge Name", "text")}
              {this.renderInput("mobile", "Incharge Mobile", "text")}
              {this.renderInput("rent", "Rent", "text")}
              <label>Renewal Date</label>
              <DatePicker
                selected={this.state.expiryDate}
                onChange={this.handleChangeExpiry}
                className="input"
              />
              {this.renderInput("emirates_id", "Emirates Id", "text")}

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>

      // <BlockUi tag="div" blocking={this.state.blocking}>
      //   <TableTitle
      //     title="Update room account"
      //     icon="tag"
      //     color="black"
      //     iconPath={dashboardIcon}
      //   />
      //   <center>
      //     <form
      //       onSubmit={this.handleSubmit}
      //       className="ui error form"
      //       style={{ width: "50%" }}
      //     >
      //       <Table>
      //         <Table.Header>
      //           <Table.Row>
      //             <Table.HeaderCell colSpan="2">
      //               Update ledger type
      //             </Table.HeaderCell>
      //           </Table.Row>
      //         </Table.Header>
      //         <Table.Body>
      //           <Table.Row>
      //             <Table.Cell width="8">
      //               {this.renderInput("room_number", "Room Number", "text")}
      //             </Table.Cell>
      //             <Table.Cell width="8">
      //               {this.renderInput("name", "Incharge Name", "text")}
      //             </Table.Cell>
      //           </Table.Row>
      //           <Table.Row>
      //             <Table.Cell width="8">
      //               {this.renderInput("mobile", "Incharge Mobile", "text")}
      //             </Table.Cell>
      //             <Table.Cell width="8">
      //               {this.renderInput("rent", "Rent", "text")}
      //             </Table.Cell>
      //           </Table.Row>

      //           <Table.Row>
      //             <Table.Cell width="8">
      //               <label>Renewal Date</label>
      //               <br />
      //               <DatePicker
      //                 selected={this.state.expiryDate}
      //                 onChange={this.handleChangeExpiry}
      //               />
      //               <br />
      //               <small>(day/month/year)</small>
      //             </Table.Cell>
      //             <Table.Cell width="8">
      //               {this.renderInput("emirates_id", "Emirates Id", "text")}
      //             </Table.Cell>
      //           </Table.Row>

      //           <Table.Row>
      //             <Table.Cell>
      //               {this.renderButton("Update")}

      //               <Link
      //                 to={`/rooms-accounts?keyword=${keyword}&status=${status}`}
      //                 className="ui secondary button"
      //                 style={{ marginBottom: "1rem" }}
      //               >
      //                 Back
      //               </Link>
      //             </Table.Cell>
      //             <Table.Cell></Table.Cell>
      //           </Table.Row>
      //         </Table.Body>
      //       </Table>
      //     </form>
      //   </center>
      // </BlockUi>
    );
  }
}

export default RoomEditForm;
